import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import localeData from 'dayjs/plugin/localeData';
import { TIME_FORMAT, DATE_FORMAT } from 'constants/localStorageConstants';

dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);
dayjs.extend(localeData);

// Override `dayjs().format()`
const originalFormat = dayjs.prototype.format;

dayjs.prototype.format = function (format) {
	const localeData = dayjs.localeData(); // Get locale data
	const defaultDateFormat = localeData.longDateFormat('L'); // Default locale date format
	const defaultTimeFormat = localeData.longDateFormat('LT'); // Default locale time format

	// Get user preferences (fall back to locale defaults)
	const userDateFormat = localStorage.getItem(DATE_FORMAT) || defaultDateFormat;
	const userTimeFormat = localStorage.getItem(TIME_FORMAT) || defaultTimeFormat;

	if (!format) {
		return originalFormat.call(this, `${userDateFormat} ${userTimeFormat}`);
	}

	// Replace date and time tokens with user preferences or defaults
	return originalFormat.call(
		this,
		format
			.replace(/\bL\b/, userDateFormat) // Replace date format
			.replace(/\bLT\b/, userTimeFormat) // Replace time format
			.replace(/\bLTS\b/, `${userTimeFormat}:ss`) // Replace long time format
	);
};

export { default } from 'dayjs';
